module.exports = __webpack_public_path__ + "media/images/svg/sphere-591f7a0c09a4d14ad5e3ba7197683359.svg";